import React from "react";
import { withRouter } from "react-router-dom";
import { HeaderContainer, ManagerTag } from "./style";
import Profile from "../profile";
import Notifications from "../notifications";
import Setting from "../setting";
import Help from "./components/help";
import Install from "./components/install";
import Logo from "../../../components/logo";
import { changePanel, getTargetPanelData } from "../../../assets/changePanel";
import { checkAccessesForManagerPanel } from "../../../assets/checkAccess";
import {
  EXPIRED_PREMIUM,
  FREE,
  NEAR_ENDING_PREMIUM,
  PREMIUM,
  PURCHASE_ACTION_NAMES
} from "../../../constants/premiumState";
import { USER_IS_OWNER } from "../../../constants/storageKeys";
import { connect } from "react-redux";
import {
  PURCHASE_STEPS_TYPE,
  PURCHASE_TYPE,
  PURCHASE_USED_KEY
} from "../../../constants/purchase";
import { PURCHASE } from "../../../constants/urls";

const Header = props => {
  const {
    RightComponent,
    LeftComponent,
    disable,
    borderless,
    isManager,
    userPremiumState,
    history,
    user
  } = props;
  const isOwner = localStorage.getItem(USER_IS_OWNER) === "true";
  const setPurchaseParameter = premiumSt => {
    let purchaseActionType;
    switch (premiumSt) {
      case FREE:
      case EXPIRED_PREMIUM:
      case "isGift":
        purchaseActionType = PURCHASE_TYPE.NEW;
        break;
      case NEAR_ENDING_PREMIUM:
        purchaseActionType = PURCHASE_TYPE.EXTEND;
        break;
    }
    history.push({
      pathname: PURCHASE,
      state: {
        [PURCHASE_USED_KEY.FORM_STEP]: PURCHASE_STEPS_TYPE.CHOOSE_PLAN,
        [PURCHASE_USED_KEY.PURCHASE_ACTION]: purchaseActionType,
        [PURCHASE_USED_KEY.OWNER_ID]: user.id
      }
    });
  };
  return (
    <HeaderContainer borderless={borderless}>
      <div className="right-side">
        {!disable &&
          (RightComponent ? (
            <RightComponent />
          ) : (
            <React.Fragment>
              <i
                className="right-side-icon icon mapsa-menu"
                title="منو"
                onClick={() => props.sidebarToggleHandler()}
              />
              <Logo />
            </React.Fragment>
          ))}
      </div>
      <div className="left-side">
        {LeftComponent ? (
          <LeftComponent />
        ) : (
          <React.Fragment>
            {isManager ? (
              <ManagerTag>
                <i className="icon mapsa-manager-head" />
                <span>شما در پنل مدیریت هستید.</span>
                {checkAccessesForManagerPanel(
                  getTargetPanelData().accesses
                ) && (
                  <div className="switch-panel" onClick={() => changePanel()}>
                    <div className="top-part">ورود به</div>
                    پنل تنخواه داری
                  </div>
                )}
              </ManagerTag>
            ) : null}
            {isOwner && userPremiumState !== PREMIUM && (
              <div className="bottom-row">
                <div
                  className="link-button"
                  onClick={e => {
                    e.stopPropagation();
                    setPurchaseParameter(userPremiumState);
                  }}
                >
                  <i className="premium-icon-white icon mapsa-premium-plan" />
                  {PURCHASE_ACTION_NAMES[userPremiumState]}
                </div>
                <div className="separator" />
              </div>
            )}
            <Install />
            <Help />
            <Notifications />
            <Setting />
            <div className="separator" />
            <Profile />
          </React.Fragment>
        )}
      </div>
      {props.children}
    </HeaderContainer>
  );
};

const mapStateToProps = store => {
  return {
    userPremiumState: store.Init.data.premium_state,
    user: store.User.data
  };
};
export default withRouter(connect(mapStateToProps)(Header));
